import { render } from "./FormOnly.vue?vue&type=template&id=34b2c97c"
import script from "./FormOnly.vue?vue&type=script&lang=js"
export * from "./FormOnly.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__